/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Grid,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import DeleteModal from 'loracoms/DeleteModal';
import ShowIf from 'loracoms/ShowIf';
import callAPI from '@/api/callAPI';
import DeviceMap from '../DeviceMap';
import styles from './styles.scss';

class BoardList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false,
      boards: props.boards,
      showModal: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { boards } = nextProps;
    if (boards !== this.props.boards) {
      this.setState({ boards });
      _.delay(() => {
        this.setState({ animation: true });
      }, 10);
    }
  }

  handleShowModal(e, id) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ deleteId: id, showModal: true });
  }

  confirmDelete() {
    const { deleteId, boards } = this.state;
    callAPI({ endpoint: `/lora/dashboards/${deleteId}`, method: 'DELETE' })
      .then(() => {
        this.setState({
          boards: _.filter(boards, item => item.id !== deleteId),
          showModal: false,
        });
      })
      .catch(() => {});
  }

  render() {
    const { pushState, appId } = this.props;
    const { boards, animation, showModal } = this.state;
    const innerWidth = window.innerWidth;
    const containerHeight = Math.ceil(boards.length / 3) * 280;
    const boardItems = boards.map((item, index) => {
      let style = {};
      const xF = innerWidth > 768 ? Math.floor(index % 3) * 100 : 0;
      const yF = innerWidth > 768 ? Math.floor(index / 3) * 100 : index * 100;
      let icons;
      let iconLength;
      const width = innerWidth > 768 ? '33.33%' : '100%';
      if (animation) {
        style = Object.assign({}, style, { transform: `translate(${xF}%,${yF}%)`, width, height: '280px' });
        iconLength = JSON.parse(item.ext).charts.length;
        if (iconLength > 6) {
          iconLength = 6;
        }
        icons = _.map(new Array(iconLength), (val, idx) =>
          (
            <span key={idx}><img styleName={`icon${_.random(1, 8)}`} alt="" /></span>
          ),
        );
      }
      const info = (
        <div
          styleName="db-info"
        >
          <p>{item.name}</p>
          <p styleName="gray">
            <span styleName="font-sm">{format(item.createdAt, 'YYYY-MM-DD')}</span>
            <span className="pull-right">
              <Link
                className="fa fa-trash-o"
                styleName="delete"
                onClick={e => this.handleShowModal(e, item.id)}
              />
            </span>
          </p>
        </div>
      );
      if (item.type === 'SINGLE') {
        if (iconLength === 1) {
          return (
            <div                                                   // eslint-disable-line
              styleName="boardItem"
              key={item.id}
              onClick={() => pushState(`/application/${appId}/dashboard/basic/${item.id}`)}
              style={style}
            >
              <div styleName="border">
                <div
                  styleName="db-preview"
                  className={styles.previewone}
                >
                  {icons}
                </div>
                {info}
              </div>
            </div>
          );
        } else if (iconLength === 2) {
          return (
            <div                                                   // eslint-disable-line
              styleName="boardItem"
              key={item.id}
              onClick={() => pushState(`/application/${appId}/dashboard/basic/${item.id}`)}
              style={style}
            >
              <div styleName="border">
                <div
                  styleName="db-preview"
                  className={styles.previewtwo}
                >
                  {icons}
                </div>
                {info}
              </div>
            </div>
          );
        } else if (iconLength > 2) {
          return (
            <div                                                   // eslint-disable-line
              styleName="boardItem"
              key={item.id}
              onClick={() => pushState(`/application/${appId}/dashboard/basic/${item.id}`)}
              style={style}
            >
              <div styleName="border">
                <div
                  styleName="db-preview"
                  className={styles.previewmore}
                >
                  {icons}
                </div>
                {info}
              </div>
            </div>
          );
        }
      }
      return (
        <div                                                       // eslint-disable-line
          styleName="boardItem"
          key={item.id}
          style={style}
          onClick={() => pushState(`/application/${appId}/dashboard/map/${item.id}`)}
        >
          <div styleName="border">
            <div
              styleName="db-preview no-padding"
            >
              <DeviceMap appId={appId} type="preview" dashId={item.id} />
            </div>
            {info}
          </div>
        </div>
      );
    });

    return (
      <Grid fluid style={{ height: `${containerHeight}px` }}>
        <Row styleName="itemLayout" className="clearfix">
          {boardItems}
        </Row>
        <DeleteModal
          showModal={showModal}
          onConfirm={this.confirmDelete}
          onCancel={() => this.setState({ showModal: false })}
          headerText={this.intlMsg.msg('delete.dashboard')}
          text={this.intlMsg.msg('delete.confirm')}
        />
        <ShowIf if={boards.length === 0}>
          <div className={styles.nodashboard}>
            <h3>
              {this.intlMsg.msg('nodashboard')}
            </h3>
            <div className={styles.desc}>
              {this.intlMsg.msg('nodashboard.desc')}
            </div>
          </div>
        </ShowIf>
      </Grid>
    );
  }
}

const mapDispatchToProps = {
  pushState: routerActions.push,
};

const propTypes = {
  intl: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  boards: PropTypes.array.isRequired,
};

BoardList.propTypes = propTypes;

export default connect(null,
  mapDispatchToProps,
)(injectIntl(CSSModules(BoardList,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/BoardList/index.jsx